import { z } from 'zod';
import { Validation } from '@mews/framework';
import { CommonProcessPaymentFormSchema } from '../ProcessPaymentFormSchema';
import { NEW_CREDIT_CARD_VALUE } from '../../../../constants';
import {
    createGatewayPaymentForNewCardSchema,
    gatewayPaymentForSelectedCardSchema,
} from '../GatewayPaymentForm/schema';

export enum GatewayPreauthorizationFormField {
    ExpirationUtc = 'expirationUtc',
}

const createGatewayPreauthorizationBaseSchema = z.object({
    [GatewayPreauthorizationFormField.ExpirationUtc]: Validation.DateTime.Utc,
});

export const createGatewayPreauthorizationForNewCardSchema = (supportedPaymentCardTypes: string[]) => {
    const newCardSchema = createGatewayPaymentForNewCardSchema(supportedPaymentCardTypes);
    return CommonProcessPaymentFormSchema.merge(newCardSchema).merge(createGatewayPreauthorizationBaseSchema);
};

export const createGatewayPreauthorizationForSelectedCardSchema = () =>
    gatewayPaymentForSelectedCardSchema.merge(createGatewayPreauthorizationBaseSchema);

export const isGatewayPreauthorizationForNewCardFormValues = (
    values: GatewayPreauthorizationFormValues
): values is GatewayPreauthorizationForNewCardFormValues => values.paymentMethodId === NEW_CREDIT_CARD_VALUE;

export type GatewayPreauthorizationForSelectedCardFormValues = z.infer<
    ReturnType<typeof createGatewayPreauthorizationForSelectedCardSchema>
>;

export type GatewayPreauthorizationForNewCardFormValues = z.infer<
    ReturnType<typeof createGatewayPreauthorizationForNewCardSchema>
>;

export type GatewayPreauthorizationFormValues =
    | GatewayPreauthorizationForSelectedCardFormValues
    | GatewayPreauthorizationForNewCardFormValues;
